import {Pagination} from 'platform/components';
import {Box, Show, Spinner} from 'platform/foundation';

import {useDetailPagination} from '../../hooks/useDetailPagination';
import type {RowControlFetchStrategy} from '../../types/RowControlFetchStrategy';

export type RowControlProps = {
  onChange: (
    entityIndex: string,
    sourceSearchParams: string,
    additionalRouteParams?: Record<string, string>
  ) => void;
  count: number;
  fetchStrategy?: RowControlFetchStrategy;
};
export function RowControl(props: RowControlProps) {
  const {rowIndex, isInvalid, onPageChange, isLoading} = useDetailPagination(
    props.onChange,
    props.fetchStrategy
  );

  if (isInvalid) {
    return null;
  }

  return (
    <Box position="relative">
      <Show when={isLoading}>
        <Spinner variant="overlay" size="small" />
      </Show>
      <Pagination
        isDisabled={isLoading}
        variant="text-only"
        showPrevButton
        showNextButton
        page={rowIndex}
        pagesQuantity={props.count}
        onPageChange={onPageChange}
      />
    </Box>
  );
}
